'use strict';

require('babel-polyfill');

require('iview/dist/styles/iview.css');

require('@/static/lib/css/iconfont/iconfont.css');

require('@/static/lib/css/dx-iconfont/iconfont.css');

require('@/static/lib/css/normallize/normallize.css');

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _router = require('./router');

var _router2 = _interopRequireDefault(_router);

var _store = require('./store');

var _store2 = _interopRequireDefault(_store);

var _App = require('./App');

var _App2 = _interopRequireDefault(_App);

var _i18n = require('plugins/i18n');

var _inject = require('plugins/inject');

var _inject2 = _interopRequireDefault(_inject);

var _decorate = require('plugins/decorate');

var _decorate2 = _interopRequireDefault(_decorate);

var _klxBaseConfig = require('klx-base-config');

var _iview = require('iview');

var _iview2 = _interopRequireDefault(_iview);

var _i18n2 = require('@/mixins/i18n');

var _i18n3 = _interopRequireDefault(_i18n2);

var _animation = require('@/mixins/animation');

var _animation2 = _interopRequireDefault(_animation);

var _remauto = require('@/mixins/remauto');

var _remauto2 = _interopRequireDefault(_remauto);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// 全局实例化注入
_vue2.default.mixin(_i18n3.default);
_vue2.default.use(_klxBaseConfig.Polyfill);
_vue2.default.use(_iview2.default);
_vue2.default.use(_inject2.default);
_vue2.default.use(_decorate2.default);
_vue2.default.mixin(_animation2.default);
_vue2.default.mixin(_remauto2.default);
_vue2.default.config.productionTip = false;
/* eslint-disable no-new */
new _vue2.default({
  el: '#app',
  router: _router2.default,
  store: _store2.default,
  i18n: _i18n.i18n,
  render: function render(h) {
    return h(_App2.default);
  }
}).$mount('#app');